export default __webpack_public_path__ + "guide--vector-tiles-standards-wo-2-480-1276ad5575be9c6ba5576f3633dffe8a.webp";